import getDateObject from '@stencil/flights-date-utils/src/get-date-object';

export const UPDATE_SEARCH_DATA = 'UPDATE_SEARCH_DATA';
export const UPDATE_SEARCH_WIDGET_LOCATION = 'UPDATE_SEARCH_WIDGET_LOCATION';
export const UPDATE_SOURCE = 'UPDATE_SOURCE';
export const UPDATE_DESTINATION = 'UPDATE_DESTINATION';
export const UPDATE_SOURCE_DESTINATION = 'UPDATE_SOURCE_DESTINATION';
export const UPDATE_DEPARTURE = 'UPDATE_DEPARTURE';
export const UPDATE_ARRIVAL = 'UPDATE_ARRIVAL';
export const UPDATE_DEPARTURE_ARRIVAL = 'UPDATE_DEPARTURE_ARRIVAL';
export const UPDATE_PASSENGERS = 'UPDATE_PASSENGERS';
export const UPDATE_FLIGHT_CLASS = 'UPDATE_FLIGHT_CLASS';
export const UPDATE_JOURNEY_TYPE = 'UPDATE_JOURNEY_TYPE';
export const UPDATE_TRAVEL_TYPE = 'UPDATE_TRAVEL_TYPE';
export const UPDATE_TEMP_SEARCH_WIDGET_DATA = 'UPDATE_TEMP_SEARCH_WIDGET_DATA';
export const UPDATE_SEARCH_WIDGET_JOURNEY_TYPE = 'UPDATE_SEARCH_WIDGET_JOURNEY_TYPE';
export const UPDATE_FLAVOUR = 'UPDATE_FLAVOUR';
export const UPDATE_SOURCE_AND_TRAVEL_TYPE = 'UPDATE_SOURCE_AND_TRAVEL_TYPE';
export const UPDATE_DESTINATION_AND_TRAVEL_TYPE = 'UPDATE_DESTINATION_AND_TRAVEL_TYPE';
export const UPDATE_OFFER_DATA = 'UPDATE_OFFER_DATA';
export const UPDATE_OUR_PROMISES_AND_USER_STORIES_DATA =
  'UPDATE_OUR_PROMISES_AND_USER_STORIES_DATA';
export const UPDATE_RECENT_SEARCH_DATA = 'UPDATE_RECENT_SEARCH_DATA';
export const UPDATE_HOME_SEO_DATA = 'UPDATE_HOME_SEO_DATA';
export const APPLY_NON_STOP_FILTER = 'APPLY_NON_STOP_FILTER';
export const APPLY_NON_STOP_RETURN_FILTER = 'APPLY_NON_STOP_RETURN_FILTER';
export const SET_HISTORY_LISTENING = 'SET_HISTORY_LISTENING';
export const SET_EXPERIMENT_DETAILS = 'SET_EXPERIMENT_DETAILS';
export const SET_EXPERIMENT_META_DATA = 'SET_EXPERIMENT_META_DATA';
export const UPDATE_SEARCH_RESULT = 'UPDATE_SEARCH_RESULT';
export const SET_FARE_OPTIONS_INFO = 'SET_FARE_OPTIONS_INFO';
export const SET_IS_FARE_OPTIONS_RECEIVED = 'SET_IS_FARE_OPTIONS_RECEIVED';
export const SET_SELECTED_FARE_IDENTIFIER = 'SET_SELECTED_FARE_IDENTIFIER';
export const SET_SELECTED_FARE_OPTION = 'SET_SELECTED_FARE_OPTION';
export const SET_HIT_EXPERIMENT_DETAILS = 'SET_HIT_EXPERIMENT_DETAILS';
export const UPDATE_ANY_TIME = 'UPDATE_ANY_TIME';
export const UPDATE_TRAVEL_DATE = 'UPDATE_TRAVEL_DATE';
export const UPDATE_ANYWHERE = 'UPDATE_ANYWHERE';
export const UPDATE_TRIP_DURATION = 'UPDATE_TRIP_DURATION';
export const SET_MWEB_TO_APP_SECTORS = 'SET_MWEB_TO_APP_SECTORS';
export const SET_UUID = 'SET_UUID';
export const SET_SSR = 'SET_SSR';
export const SET_IS_MODIFY_SEARCH_OPEN_IN_SRP = 'SET_IS_MODIFY_SEARCH_OPEN_IN_SRP';

export const flightClassList = {
  E: 'Economy',
  B: 'Business',
  F: 'First class',
  W: 'Premium Economy'
};

export function updateSearchData(data) {
  return {
    type: UPDATE_SEARCH_DATA,
    props: {
      ...data,
      departure: getDateObject(data.departure),
      arrival: getDateObject(data.arrival)
    }
  };
}

export const updateSearchWidgetLocation = actionData => {
  return {
    type: UPDATE_SEARCH_WIDGET_LOCATION,
    props: { ...actionData }
  };
};

export function updateSource(source) {
  return {
    type: UPDATE_SOURCE,
    props: { source }
  };
}

export function updateDestination(destination) {
  return {
    type: UPDATE_DESTINATION,
    props: { destination }
  };
}

export function updateSourceDestination(data) {
  return {
    type: UPDATE_SOURCE_DESTINATION,
    props: { ...data }
  };
}

export function swapSourceAndDestination() {
  return (dispatch, getState) => {
    const { source, destination } = getState().home;
    dispatch(updateSourceDestination({ source: destination, destination: source }));
  };
}

export function swapSearchWidgetSourceAndDestination() {
  return (dispatch, getState) => {
    const { source, destination } = getState().home?.tempSearchWidget;
    dispatch(updateTempSearchWidgetData({ source: destination, destination: source }));
  };
}

export function updateDeparture(departure) {
  return {
    type: UPDATE_DEPARTURE,
    props: {
      departure: getDateObject(departure)
    }
  };
}

export function updateArrival(arrival) {
  return {
    type: UPDATE_ARRIVAL,
    props: {
      arrival: getDateObject(arrival)
    }
  };
}

export function updateDepartureArrival(departure, arrival) {
  return {
    type: UPDATE_DEPARTURE_ARRIVAL,
    props: {
      departure: getDateObject(departure),
      arrival: getDateObject(arrival)
    }
  };
}

export function updateDepartureArrivalObject(departure, arrival) {
  return {
    type: UPDATE_DEPARTURE_ARRIVAL,
    props: {
      departure,
      arrival
    }
  };
}

export function updatePassengers(passengers) {
  return {
    type: UPDATE_PASSENGERS,
    props: { passengers }
  };
}

export function updateFlightClass(flightClass) {
  return {
    type: UPDATE_FLIGHT_CLASS,
    props: { flightClass }
  };
}

export function updateJourneyType(journeyType, arrival?) {
  return {
    type: UPDATE_JOURNEY_TYPE,
    props: {
      journeyType,
      arrival: arrival ? getDateObject(arrival) : null
    }
  };
}

export function updateTravelType(travelType) {
  return {
    type: UPDATE_TRAVEL_TYPE,
    props: { travelType }
  };
}

export function updateFlavour(flavour) {
  return {
    type: UPDATE_FLAVOUR,
    props: { flavour }
  };
}

export function updateSourceAndTravelType(source, travelType) {
  return {
    type: UPDATE_SOURCE_AND_TRAVEL_TYPE,
    props: { source, travelType }
  };
}

export function updateDestinationAndTravelType(destination, travelType) {
  return {
    type: UPDATE_DESTINATION_AND_TRAVEL_TYPE,
    props: { destination, travelType }
  };
}

export function updateOfferData(offersData) {
  return {
    type: UPDATE_OFFER_DATA,
    props: { offersData }
  };
}

export function updateOurPromisesAndUserStoriesData(actionData) {
  return {
    type: UPDATE_OUR_PROMISES_AND_USER_STORIES_DATA,
    props: {
      ourPromises: actionData?.our_promises || {},
      userStories: actionData?.user_stories || {}
    }
  };
}

export function updateRecentSearchData(recentSearchData) {
  if (recentSearchData.length) {
    const item = recentSearchData[0];
    return {
      type: UPDATE_RECENT_SEARCH_DATA,
      props: {
        recentSearchData,
        source: item.source,
        destination: item.destination,
        departure: getDateObject(item.departure.dateObj),
        arrival: item.arrival ? getDateObject(item.arrival.dateObj) : null,
        passengers: item.passengers,
        flightClass: item.flightClass,
        journeyType: item.journeyType,
        travelType: item.travelType
      }
    };
  }
  return {
    type: UPDATE_RECENT_SEARCH_DATA,
    props: { recentSearchData }
  };
}

export function updateTempSearchWidgetData(searchWidgetData) {
  const arrival = searchWidgetData.arrival;
  const departure = searchWidgetData.departure;
  return {
    type: UPDATE_TEMP_SEARCH_WIDGET_DATA,
    props: {
      ...searchWidgetData,
      ...(arrival ? { arrival: arrival?.dateObj ? arrival : getDateObject(arrival) } : null),
      ...(departure
        ? { departure: departure?.dateObj ? departure : getDateObject(departure) }
        : null)
    }
  };
}

export function updateSEOData(homeSeoData) {
  return {
    type: UPDATE_HOME_SEO_DATA,
    props: { homeSeoData }
  };
}

export function applyNonStopFilter(actionData) {
  return {
    type: APPLY_NON_STOP_FILTER,
    props: {
      isNonStop: actionData
    }
  };
}

export function applyNonStopReturnFilter(actionData) {
  return {
    type: APPLY_NON_STOP_RETURN_FILTER,
    props: {
      isNonStopReturn: actionData
    }
  };
}

export const setHistoryListening = actionData => {
  return {
    type: SET_HISTORY_LISTENING,
    props: {
      isHistoryListening: actionData
    }
  };
};

export const setExperimentDetails = actionData => {
  return {
    type: SET_EXPERIMENT_DETAILS,
    props: actionData
  };
};

export const setExperimentMetaData = actionData => {
  return {
    type: SET_EXPERIMENT_META_DATA,
    props: actionData
  };
};

export const setUpdateSearchResult = actionData => {
  return {
    type: UPDATE_SEARCH_RESULT,
    props: {
      updateSearchResult: actionData
    }
  };
};

export const setFareOptionsInfo = actionData => {
  return {
    type: SET_FARE_OPTIONS_INFO,
    props: {
      fareOptionsInfo: actionData
    }
  };
};

export const setIsFareOptionsReceived = actionData => {
  return {
    type: SET_IS_FARE_OPTIONS_RECEIVED,
    props: {
      isFareOptionsReceived: actionData
    }
  };
};

export const setMwebToAppSectors = actionData => {
  return {
    type: SET_MWEB_TO_APP_SECTORS,
    props: {
      mwebToAppSectors: actionData
    }
  };
};

export const setSelectedFareIdentifier = actionData => {
  return {
    type: SET_SELECTED_FARE_IDENTIFIER,
    props: {
      selectedFareIdentifier: actionData
    }
  };
};

export const setSelectedFareOption = actionData => {
  return {
    type: SET_SELECTED_FARE_OPTION,
    props: {
      selectedFareOptionInfo: actionData
    }
  };
};

export const setHitExperimentDetails = actionData => {
  return {
    type: SET_HIT_EXPERIMENT_DETAILS,
    props: {
      hitExperimentDetails: actionData
    }
  };
};

export function updateAnyTime(anyTime) {
  return {
    type: UPDATE_ANY_TIME,
    props: { anyTime }
  };
}

export function updateAnywhere(isAnywhere) {
  return {
    type: UPDATE_ANYWHERE,
    props: { isAnywhere }
  };
}

export function updateTravelDate(travelDate) {
  return {
    type: UPDATE_TRAVEL_DATE,
    props: { travelDate: travelDate ? getDateObject(travelDate) : null }
  };
}

export function updateTripDuration(tripDuration) {
  return {
    type: UPDATE_TRIP_DURATION,
    props: { tripDuration }
  };
}

export function setUUID(uuid) {
  return {
    type: SET_UUID,
    props: { uuid }
  };
}

export function setSSR(ssr) {
  return {
    type: SET_SSR,
    props: { ssr }
  };
}

export const setModifySearchOpenInSRP = actionData => {
  return {
    type: SET_IS_MODIFY_SEARCH_OPEN_IN_SRP,
    props: {
      isModifySearchOpenInSRP: actionData
    }
  };
};
